<script>
    import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';
    import { logoutUser } from '/public/services/users/users.js';
    import ThexaHero from '/shared/c/logo/ThexaHero.svelte';

    let loggingOut = false;
    let hasLoggedOut = false;

    onMount(() => {
        loggingOut = true;
        
        logoutUser().then(res => {
            if (res.success) {                
                hasLoggedOut = true;
                loggingOut = false;                
            }
        });
    });

</script>
<div class='vh-100 mt-5'>
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-4 col-xxl-4">
               
                <ThexaHero/>
                
                <h3 class='text-center mb-3'>
                    Session expired
                </h3>

                <div class='text-center mb-3'>
                    For your security, we signed you out after a period of<br/>
                    inactivity. Please <b><a href='/'>log in</a></b> again to continue. 
                </div>

                {#if loggingOut === true}

                    <div class='mb-5 text-center' in:fade out:fade>
                        <h4>
                            <span class='ajax-ball-loader'></span>
                        </h4>
                    </div>                                     

                {/if}
                                           
        </div>
    </div>
</div>